import { LocaleEnum, Metadata } from 'generated/apolloComponents'
import useTranslation from 'next-translate/useTranslation'
import CustomHead from '@/components/molecules/CustomHead'
import { RoleData, roles } from '@/data/roleData'
import SalaryIndexTemplate from '@/components/templates/SalaryReportIndex'

type Props = {
  data: RoleData[]
}

const SalaryIndex = ({ data }: Props) => {
  const { t, lang } = useTranslation('it_report')
  const metaData: Metadata = {
    title: t('title'),
    description: t('description'),
  }
  return (
    <>
      <CustomHead metaData={metaData} />
      <SalaryIndexTemplate data={data} />
    </>
  )
}

export const getStaticProps = async () => ({
  props: {
    data: roles,
  },
})

export default SalaryIndex
